export default __webpack_public_path__ + "static/media/06-family_thumb.16cb9d19.png";